export enum Integration {
	GOOGLE_SERVICE = 'google-invites',
	MICROSOFT_SERVICE = 'microsoft-invites',
	PLATFORM_SLACK_SERVICE = 'slack',
}

export type GenericIntegrations =
	| typeof Integration.MICROSOFT_SERVICE
	| typeof Integration.GOOGLE_SERVICE;

export enum ScopeState {
	NO_SCOPE = 'no-scope',
	PARTIAL_SCOPE = 'partial-scope',
	FULL_SCOPE = 'full-scope',
}

export type SlackWorkspace = {
	id: string;
	name: string;
	avatar: string;
};

export type GenericIntegrationMetadata = {
	scopeState: ScopeState;
};

export type SlackIntegtationMetadataTeam = GenericIntegrationMetadata & SlackWorkspace;

export type SlackIntegtationMetadata = {
	teams: SlackIntegtationMetadataTeam[];
};

export type IntegrationMetadata = {
	[id in GenericIntegrations]?: GenericIntegrationMetadata;
} & {
	[Integration.PLATFORM_SLACK_SERVICE]?: SlackIntegtationMetadata;
};

export interface IntegrationsResponse {
	enabledIntegrations: Integration[];
	connectedIntegrations: Integration[];
	integrationMetadata?: IntegrationMetadata;
}

export type IntegrationsScopeState = {
	noScope: Set<Integration>;
	partialScope: Set<Integration>;
};

export interface OrgSettings {
	isSlackImportedInvitesEnabled?: boolean;
	is3rdPartyInvitesEnabled?: boolean;
}
